import translations from './translations';
export default function customTranslate(template, replacements) {
    replacements = replacements || {};
    template = translations[template] || template;
    return template.replace(/{([^}]+)}/g, (_, key) => {
        let str = replacements[key];
        if (translations[replacements[key]] != null && translations[replacements[key]] != 'undefined') {
            str = translations[replacements[key]];
        }
        return str || `{${key}}`;
    });
}
